
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { ProductGroup } from "finx/lib/travel/components/Product/ProductGroup";

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="p" components={components}>{`So you shave your head or are interested in trying it out?`}</MDXTag>
<MDXTag name="h2" components={components}>{`Head Shaving Benefits`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Dry your head easily.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Can be cooler in hot weather.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`You can save money and cut your hair as often as you want.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Flexibility of cutting your own hair where you want.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`You can avoid looking for or booking hair cuts.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`You can still get dandruff, but it is less likely.`}</MDXTag>
</MDXTag>
<MDXTag name="h2" components={components}>{`Head Shaving Negatives`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Chilly in the cold without headgear.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Can be messy and require cleanup.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Less styling options? ;)`}</MDXTag>
</MDXTag>
<MDXTag name="h2" components={components}>{`We Can Make It`}</MDXTag>
<MDXTag name="p" components={components}>{`If you are going on a short trip, you might like to get your head shaved before you leave. Depending on how often you shave, this might mean you do not need to concern yourself with shaving on your trip.`}</MDXTag>
<MDXTag name="p" components={components}>{`You might decide to grow your hair out while you are on holiday... but you probably did not come here for that, so...`}</MDXTag>
<MDXTag name="h2" components={components}>{`Shaving While Away`}</MDXTag>
<MDXTag name="p" components={components}>{`If you do need to shave while you are away you can decide between:`}</MDXTag>
<MDXTag name="h3" components={components}>{`Getting your head shaved by someone`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`No need to take any shaving gear, saving weight and space.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Get someone else to do it and clean up the mess.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`The shave should be pretty quick.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`You might have to spend some time looking for a place to get shaved.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`It might be expensive.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Some people like the social aspect of having a chat.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Professional facilities and equipment.`}</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components}>{`Taking your own shaving gear`}</MDXTag>
<MDXTag name="p" components={components}>{`Once you decide to take your own gear, you need to decide what is the best shaving option for you and whether you shave your head smooth and bald, or clip to your desired length.`}</MDXTag>
<MDXTag name="h2" components={components}>{`Equipment Consideration`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Hair length: short or smooth (bald)?`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Cheap or expensive:`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul">{`Do you want a quality option that will `}<MDXTag name="em" components={components} parentName="li">{`hopefully`}</MDXTag>{` last you a long time with a good warranty, or something cheaper that may not be a concern if it is lost or broken.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Cheaper options might take longer to do your hair.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Expensive options might have more features, or a premium look and feel.`}</MDXTag>
</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Be aware of what voltages your shaver electric shaver supports if going somewhere with different voltages. Some shavers support a range of voltages, which is great for travel.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Manual methods do not have to worry about different electricity and voltages you may find around the world.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`You might find others are not very appreciative of you shaving your head in public areas like hostel bathrooms.`}</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components}>{`Maintenance`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Check the instructions:`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul">{`How to clean and how often. Often a brush is included with a shaver and some can be run under water, but please check to make sure so you do not ruin your shaver.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Do you need to oil the blades or internals and how often. Some clipper oil can save your blades, save you money and save you time with sharper blades for longer.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Some people also sharpen their clipper blades.`}</MDXTag>
</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="h3" components={components}>{`Getting Ready For a Trip`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Take spare blades or replace them before a trip if you think they will not last.`}</MDXTag>
</MDXTag>
<MDXTag name="h2" components={components}>{`Shaving Options`}</MDXTag>
<ProductGroup {...props}/>
           </MDXTag>
  }
}
  